export default __webpack_public_path__ + "static/media/RadiationTableImg.27c6dc9b.png";